(() => {
  const nativeFetch = window.fetch.bind(window);

  const isCartAddRequest = (input) => {
    try {
      const rawUrl = typeof input === 'string' ? input : input?.url;
      if (!rawUrl) return false;
      const url = new URL(rawUrl, window.location.origin);
      return /\/cart\/add(?:\.js)?$/.test(url.pathname);
    } catch (_error) {
      return false;
    }
  };

  window.fetch = function localeAwareCartFetch(input, init) {
    if (!isCartAddRequest(input) || !init?.body) {
      return nativeFetch(input, init);
    }

    let nextInit = init;

    if (init.body instanceof FormData) {
      if (init.body.has('sections') && !init.body.has('sections_url')) {
        init.body.append('sections_url', window.location.pathname);
      }
    } else if (typeof init.body === 'string') {
      const contentType = new Headers(init.headers || {}).get('Content-Type') || '';

      if (contentType.toLowerCase().includes('application/json')) {
        try {
          const payload = JSON.parse(init.body);

          if (payload?.sections && !payload.sections_url) {
            nextInit = {
              ...init,
              body: JSON.stringify({
                ...payload,
                sections_url: window.location.pathname,
              }),
            };
          }
        } catch (_error) {
          // Leave non-JSON or malformed requests untouched.
        }
      }
    }

    return nativeFetch(input, nextInit);
  };
})();
